export default "__VITE_ASSET__uwU2jFot__"